// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"b872caf5","188":"636cb224","284":"5f405c74","448":"48a1958c","472":"f3ff5c38","484":"c0eb434d","664":"48a1958c"}[chunkId] + ".chunk.css";
};